import WidgetModule from "@eisinc/Overrides/Widgets/Basic/Subscribe";

export * from "@eisinc/Overrides/Widgets/Basic/Subscribe";

export default WidgetModule;
